import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { ActivatedRoute } from '@angular/router';
import { AlertController } from '@ionic/angular';


export interface Roles {
  Tipo:string;
  Id:number;
}


@Component({
  selector: 'app-tabla-roles',
  templateUrl: './tabla-roles.component.html',
  styleUrls: ['./tabla-roles.component.scss'],
})
export class TablaRolesComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Tipo', 'Privilegios', 'accion'];
  dataSource: MatTableDataSource<Roles>;
  selection = new SelectionModel<Roles>(true, []);

    @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  AllPrivilegios =[];

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService, private activated: ActivatedRoute,
    private alertController: AlertController) {
    this.dataSource = new MatTableDataSource([])
  }

  ngOnInit() {
    this.getPrivilegios()
    this.getRoles()
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  async AgregarRol(){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Ingresa el nombre del nuevo rol',
      inputs: [
        {
          name: 'rol',
          type: 'text',
          placeholder: 'Ej: Editor'
        },
       

      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }, {
          text: 'Agregar',
          handler: (data) => {
            this.GuardarRol(data.rol)
          }
        }
      ]
    });

    await alert.present();
  }

  async EditarRol(id){
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Ingresa el nuevo nombre del rol',
      inputs: [
        {
          name: 'rol',
          type: 'text',
          placeholder: 'Ej: Editor'
        },
       

      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }, {
          text: 'Editar',
          handler: (data) => {
            this.ActualizarRol(data.rol, id)
          }
        }
      ]
    });

    await alert.present();
  }

  getRoles() {
    this.utilidades.Loading("Cargando roles")
    this.conexion.getRoles().subscribe((resp) => {
      this.utilidades.CerrarLoading();
      if (resp.Respuesta == "Exito") {
        this.utilidades.Depuracion(resp.Datos, "console", "")
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.ngAfterViewInit()
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  getPrivilegios() {
    this.conexion.getPrivilegios().subscribe((resp) => {
      if (resp.Respuesta == "Exito") {
        this.AllPrivilegios=resp.Datos
        this.utilidades.Depuracion(this.AllPrivilegios, "console", "")
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  GuardarRol(rol) {
    this.utilidades.Loading("Guardando Rol")
    this.conexion.GuardarRol(rol).subscribe((resp) => {
      this.utilidades.CerrarLoading()
       this.utilidades.Toast(resp.Mensaje)
       this.getRoles()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  ActualizarRol(rol, id) {
    this.utilidades.Loading("Editando Rol")
    this.conexion.EditarRol(rol, id).subscribe((resp) => {
      this.utilidades.CerrarLoading()
       this.utilidades.Toast(resp.Mensaje)
       this.getRoles()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  ActualizarPrivilegios(row) {
    this.utilidades.Loading("Actualizando privilegios")
    this.conexion.ActualizarPrivilegios(row.Id, row.Privilegios).subscribe((resp) => {
      this.utilidades.CerrarLoading()
       this.utilidades.Toast(resp.Mensaje)
       this.getRoles()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  EliminarRol(id){
    if(confirm("¿Eliminar este rol?")){
      this.utilidades.Loading("Eliminando Rol")
      this.conexion.EliminarRol(id).subscribe((resp) => {
        this.utilidades.CerrarLoading()
         this.utilidades.Toast(resp.Mensaje)
         this.getRoles()
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
  
        this.utilidades.ValidarUser(err)
      })
    }
  }
}
